import React from 'react';
import { SVGProps } from './type';

const Icon = ({ fill }: SVGProps) => (
  <g>
    <path
      d="M11.533 1.333c1.215 0 2.2.985 2.2 2.2v6.934c0 1.215-.985 2.2-2.2 2.2h-.142c-.101 1.121-1.044 2-2.191 2H4.433c-1.215 0-2.2-.985-2.2-2.2V5.533c0-1.215.985-2.2 2.2-2.2h.143c.1-1.12 1.043-2 2.19-2h4.767zM8.867 4.667h-4.1c-.663 0-1.2.537-1.2 1.2v6.266c0 .663.537 1.2 1.2 1.2h4.1c.662 0 1.2-.537 1.2-1.2V5.867c0-.663-.538-1.2-1.2-1.2zm2.333-2H7.1c-.471 0-.879.271-1.075.666H9.2c1.215 0 2.2.985 2.2 2.2v5.784c.568-.096 1-.59 1-1.184V3.867c0-.663-.537-1.2-1.2-1.2z"
      transform="scale(1.5 1.5)"
      fill={fill}
    />
  </g>
);

export default Icon;
